// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from 'modules/queries/api';

/**
 * @param {import('club-sauce/public/notifications/index.raw').LWApiPublicNotificationCurrentParamsRawI} [params]
 * @param {object} [options]
 * @param {import('@tanstack/react-query').UseQueryOptions['enabled']} [options.enabled]
 * @param {number} [options.refetchInterval]
 */
const useNotificationsCurrent = (params, options) =>
	useQuery({
		queryKey: ['/notifications/current', params],
		queryFn: () => api.notifications.apiRaw.current(params),
		enabled: options?.enabled,
		refetchInterval: options?.refetchInterval,
	});

export default useNotificationsCurrent;
